import { Space } from "~/lib/types";
import { WorkspacesEntryPage as WorkspacesPage } from "~/pages/space/workspaces/Workspaces";

interface WorkspacesEntryPageProps {
  space: Space;
}

const WorkspacesEntryPage = ({ space }: WorkspacesEntryPageProps) => {
  return <WorkspacesPage space={space} />;
};

export default WorkspacesEntryPage;
